import React from 'react';

import { Link } from '@ha/dsl';

import { InstagramCard } from 'ha/components.legacy/InstagramCard';
import { Plot as PlotCard } from 'ha/components.legacy/Plot';
import { Tablau } from 'ha/components.legacy/Tablau';
import { YoutubeCard } from 'ha/components.legacy/YoutubeCard';

import { isInternalWithSubdomain } from 'ha/utils/urls/isInternalWithSubdomain';
import { isExternalUrl } from 'ha/utils/urls/isExternalUrl';
import {
  isPlotlyUrl,
  isInfogramUrl,
  isTableaUrl,
} from 'ha/utils/thirdParty/plots';
import { isInstagramPost } from 'ha/utils/thirdParty/isInstagramPost';
import { isYoutubeVideo } from 'ha/utils/thirdParty/youtubeUrl';
import { isSpotifyEpisode } from 'ha/utils/thirdParty/spotify';
import { fixHref } from 'ha/utils/urls/fixHref';
import { parse } from 'ha/utils/urls/parse';
import { SpotifyCard } from '../SpotifyCard';

interface Props {
  children: React.ReactNode;
  href: string;
}

const MarkdownLink: React.FC<Props> = ({ children, href }) => {
  const text = Array.isArray(children) ? children[0] : children;

  if (!text || text === href) {
    if (isYoutubeVideo(href)) {
      return <YoutubeCard src={href} />;
    }
    if (isInstagramPost(href)) {
      return <InstagramCard src={href} />;
    }
    if (isTableaUrl(href)) {
      return <Tablau href={href} />;
    }
    if (isPlotlyUrl(href) || isInfogramUrl(href)) {
      return <PlotCard src={href} />;
    }
    if (isSpotifyEpisode(href)) {
      return <SpotifyCard src={href} />;
    }
  }

  if (href.includes('mailto:')) {
    return (
      <Link to={href} kind="mint-underline" target="_blank">
        {children}
      </Link>
    );
  }

  const fixedHref = fixHref(href);

  if (isExternalUrl(href) || isInternalWithSubdomain(href)) {
    return (
      <Link to={fixedHref} target="_blank" kind="mint-underline">
        {children}
      </Link>
    );
  }

  const parsedHref = parse(fixedHref);

  return (
    <Link
      to={`${parsedHref.pathname}${parsedHref.search || ''}`}
      kind="mint-underline"
      target="_blank"
    >
      {children}
    </Link>
  );
};

export { MarkdownLink };
